import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import './Search.css';
import logo from "../../asset/EssilorLuxottica.svg";
import { Project } from '../TableAPI/CostSumTable';
import { BASE_API } from '../TableAPI/Constant';
import { UserContext } from '../Login/Login';
import CostSumData from '../TableAPI/CostSumData';
import CostSumDataMulti from '../TableAPI/CostSumDataMulti';
import { Box, Flex, Image, Button, Input, Text, Stack, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { FaSearch } from 'react-icons/fa';
import ClockBar from './ClockBar';

const Search = () => {
  const [showTable, setShowTable] = useState(false);
  const [dataCostSummaries, setDataCostSummaries] = useState<Project[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState<Project[]>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const mainProjectId = useContext(UserContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const mainProjectId = sessionStorage.getItem('mainProjectId') || '';
        const response = await axios.get(`${BASE_API}/costSummaries/current/${mainProjectId}/`);
        const responseData = response.data;
        if (responseData && responseData.data) {
          setDataCostSummaries(responseData.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [mainProjectId]);

  const handleInputChange = (value: string) => {
    setInputValue(value);
    if (value.trim() === '') {
      setSuggestions([]);
      setErrorMessage('');
      return;
    }

    const lastInput = value.split(',').pop()?.trim() || '';
    const filteredSuggestions = dataCostSummaries.filter(project =>
      (typeof project.form_details.NAME === 'string' && project.form_details.NAME.toLowerCase().includes(lastInput.toLowerCase())) ||
      project.project_id.toString().includes(lastInput)
    );
    setSuggestions(filteredSuggestions);
    if (filteredSuggestions.length === 0) {
      setErrorMessage('No suggestions found');
    } else {
      setErrorMessage('');
    }
  }

  const handleSelectSuggestion = (selectedProject: Project) => {
    const existingProjects = inputValue.split(',').map(project => project.trim()).filter(project => project !== '');
    existingProjects[existingProjects.length - 1] = selectedProject.form_details.NAME.toString();
    const newInputValue = existingProjects.join(', ') + ', ';
    setInputValue(newInputValue);
    setSuggestions([]);
  }

  const handleSearchClick = () => {
    const projectNames = inputValue.split(',').map(name => name.trim()).filter(name => name !== '');
    const selectedProjects = dataCostSummaries
      .filter(project => projectNames.includes(project.form_details.NAME.toString()))
      .map(project => project.project_id.toString());
    setSelectedProjects(selectedProjects);
    setShowTable(true);
  }

  const handleLogoClick = () => {
    window.location.href = '/search';
  };

  return (
    <Box>
      <Flex alignItems="center" justifyContent="space-between" mb={7} p={4} bg="gray.100" borderRadius="md" boxShadow="md">
        <Image src={logo} alt="" cursor="pointer" onClick={handleLogoClick} />
        <Box justifyContent="center" ml={-60}>
          <ClockBar />
        </Box>
        <Button as="a" href='/upload' bg="#414042" color="white" p={3} borderRadius="md" boxShadow="md"
          _hover={{ bg: "#E6E7E8", color: "black", boxShadow: "lg", transform: "scale(1.05)" }}
          _focus={{ boxShadow: "outline" }}>
          UPLOAD
        </Button>
      </Flex>

      <Flex justifyContent="center" alignItems="center" mb={4}>
        <Box width={{ base: "100%", md: "600px", lg: "800px" }} position="relative">
          <InputGroup>
            <InputLeftElement
              children={<FaSearch color="gray.300" style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={handleSearchClick}/>}
            />
            <Input
              placeholder="Type Project Name or Project Code"
              value={inputValue}
              onChange={(e) => handleInputChange(e.target.value)}
              bg="white"
              color="black"
              border="2px"
              borderColor="gray.300"
              _placeholder={{ color: '#BCBEC0' }}
              p={3}
              pl={10}
            />
          </InputGroup>

          {errorMessage && <Text color="#EE312F" mt={3}>{errorMessage}</Text>}

          {/* Mostra i suggerimenti di ricerca */}
          {suggestions.length > 0 && (
            <Stack spacing={1} mt={2} borderWidth={1} borderRadius="md" borderColor="gray.200" bg="white">
              {suggestions.map(project => (
                <Box
                  key={project._id}
                  onClick={() => handleSelectSuggestion(project)}
                  cursor='pointer'
                  textDecoration='underline'
                  _hover={{ backgroundColor: '#f0f0f0' }}
                  p={3}
                >
                  {project.form_details.NAME} ({project.project_id})
                </Box>
              ))}
            </Stack>
          )}
        </Box>
      </Flex>

      {/* Mostra i dati dei progetti selezionati */}
      {showTable && selectedProjects.length === 1 && (
        <CostSumData projectId={selectedProjects[0]} />
      )}

      {showTable && selectedProjects.length > 1 && (
        <CostSumDataMulti projectIds={selectedProjects} />
      )}
    </Box>
  );
};

export default Search;